const cartBundler = document.querySelectorAll('.bundler-submit');
const checkboxes = document.querySelectorAll('.bundler-checkbox');
const mainProductInput = document.querySelector('.movemints__pdp .button-form__submit');
const inputId = mainProductInput.querySelector('input[name="id"]');
const mainProductPrice = mainProductInput.querySelector('.btn-price-r');
const subsPrice = mainProductInput.querySelector('.btn-price-s');
const ProductPrice = Number(mainProductPrice.textContent.split(' ')[1].split('.').join(''));
console.log(inputId)
const selectedValues = [];
let totalPrice = 0;
let pricesArray = [];
let upProductPrice;
pricesArray[0] = ProductPrice;
selectedValues[0] = inputId.value;

inputId.addEventListener('change', (e) => {
  selectedValues[0] = inputId.value;
  setTimeout(() => {
      updateBundleProductPricing();
  }, 1000)
});
setTimeout(() => {
  selectedValues[0] = inputId.value;
      updateBundleProductPricing();
}, 2000)
updateBundleProductPricing();
function updateBundleProductPricing(){
    const mainProductInput = document.querySelector('.movemints__pdp .button-form__submit');
    const mainProductPrice = mainProductInput.querySelector('.btn-price-r');
    upProductPrice = Number(mainProductPrice.innerHTML.trim(' ').split(' ')[1].split('.').join(''));
    console.log(upProductPrice,mainProductPrice , 'price', )
    pricesArray[0] = upProductPrice;
        if (selectedValues.length > 1){
          pricesArray[0] = upProductPrice;
          console.log(upProductPrice, pricesArray);
        }else{
          pricesArray[0] = 0.00;
        }
    totalPrice = pricesArray.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    document.querySelector('.price-bt').textContent = '$ '+(totalPrice / 100).toFixed(2);
    document.querySelector('.saved-p').textContent = '$ ' + ((totalPrice / 100) * 0.15).toFixed(2);
};
  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', (event) => {
      const checkboxValue = event.target.value;
      const priceValue = Number(event.target.getAttribute('data-price'));
      if (event.target.checked) {
        selectedValues.push(checkboxValue);
        pricesArray.push(priceValue);
      } else {
        const index = selectedValues.indexOf(checkboxValue);
        const priceIndex = pricesArray.indexOf(priceValue);
        if (index !== -1) {
          selectedValues.splice(index, 1);
          pricesArray.splice(priceIndex, 1);
        }
      }
      updateBundleProductPricing();
    });
  });

 
cartBundler.forEach(el => {
  el.addEventListener('click', function (e) {
    let cart = document.querySelector('cart-drawer');
    let form = document.querySelector('form[action="/cart/add"]');
    let formData = new FormData();
    selectedValues.map((item, i) => (formData.append(`items[${i}][id]`, item)))
    if (cart) {
          formData.append(
            'sections',
             cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      return response.json();
    })
    .then(response => {
      cart.renderContents(response);
      cart.classList.remove('is-empty');
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    
  });
});
